import { Periodo } from "../model/periodo";
import { Persona } from "../model/persona";
import { Sede } from "../model/sede";
import { Uaa } from "../model/uaa";
import { Usuario } from "../model/usuario";

export class PersonaDto {
    persona: Persona;
	periodo: Periodo;
	usuario: Usuario;
	sede: Sede;
	dependencia: string;
	uaa: Uaa;
}
